"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeDiffPicker = void 0;
const consts_1 = require("@opsbase/lib-time/consts");
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const Dialog_1 = __importDefault(require("@opsbase/web-dialogs/Dialog"));
const DialogSize_1 = __importDefault(require("@opsbase/web-dialogs/Dialog/DialogSize"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const makePicker_1 = __importDefault(require("@opsbase/web-pickers/helpers/makePicker"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem/MenuItem"));
const Select_1 = __importDefault(require("@opsbase/web-ui/Select"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const calcTimeLabel_1 = __importDefault(require("../helpers/calcTimeLabel"));
const TimeDiffs = [
    consts_1.HOUR_MINS,
    consts_1.HOUR_MINS * 2,
    consts_1.HOUR_MINS * 6,
    consts_1.HOUR_MINS * 12,
    consts_1.DAY_MINS,
    consts_1.DAY_MINS * 2,
    consts_1.DAY_MINS * 3,
    consts_1.WEEK_MINS,
];
exports.TimeDiffPicker = (0, makePicker_1.default)((props) => {
    const { value, onChange } = props;
    const [showCustom, setShowCustom] = (0, react_1.useState)(false);
    const [customType, setCustomType] = (0, react_1.useState)('mins');
    const [customValue, setCustomValue] = (0, react_1.useState)(30);
    const isCustom = TimeDiffs.indexOf(value) < 0;
    const handleChange = (0, react_1.useCallback)(v => {
        if (v === 'custom')
            return setShowCustom(true);
        onChange === null || onChange === void 0 ? void 0 : onChange(parseInt(v));
    }, [onChange]);
    const handleChangeCustom = (0, react_1.useCallback)(() => {
        setShowCustom(false);
        switch (customType) {
            case 'mins':
                return onChange(customValue);
            case 'hours':
                return onChange(customValue * 60);
            case 'days':
                return onChange(customValue * 60 * 24);
            case 'weeks':
                return onChange(customValue * 60 * 24 * 7);
        }
    }, [onChange, customType, customValue]);
    const handleCloseCustom = (0, react_1.useCallback)(() => setShowCustom(false), []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Select_1.default, Object.assign({}, props, { value: value, onChange: handleChange }),
            TimeDiffs.map(td => (react_1.default.createElement(MenuItem_1.default, { key: td + '', value: td + '' },
                react_1.default.createElement(Text_1.default, null, (0, calcTimeLabel_1.default)(td))))),
            isCustom && (react_1.default.createElement(MenuItem_1.default, { value: value + '' },
                react_1.default.createElement(Text_1.default, null, (0, calcTimeLabel_1.default)(value)))),
            react_1.default.createElement(MenuItem_1.default, { value: 'custom' },
                react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('custom')))),
        showCustom && (react_1.default.createElement(Dialog_1.default, { size: DialogSize_1.default.X450_Y250, open: true, onClose: handleCloseCustom, buttonsRight: react_1.default.createElement(Button_1.default, { onClick: handleChangeCustom, label: lib_i18n_1.default.t('ok') }) },
            react_1.default.createElement(Horizontal_1.default, { gutter: true, padding: true, style: { marginTop: 24 } },
                react_1.default.createElement(Pane_1.default, { grow: true },
                    react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { fullWidth: true, white: true, noMargin: true, type: 'number', value: customValue, onBlur: setCustomValue })),
                react_1.default.createElement(Pane_1.default, { grow: true },
                    react_1.default.createElement(Select_1.default, { white: true, fullWidth: true, value: customType, onChange: setCustomType },
                        react_1.default.createElement(MenuItem_1.default, { value: 'mins' }, "Mins"),
                        react_1.default.createElement(MenuItem_1.default, { value: 'hours' }, "Hours"),
                        react_1.default.createElement(MenuItem_1.default, { value: 'days' }, "Days"),
                        react_1.default.createElement(MenuItem_1.default, { value: 'weeks' }, "Weeks"))))))));
});
exports.default = exports.TimeDiffPicker;
